import {Integer} from '@pb/kit-component-formatters';
import {isValidEmail} from '@pb/kit-util-is-valid-email';

import {
    COLUMNS,
    HEADERS,
    INVALID_CITY_MESSAGE,
    INVALID_EMAIL_MESSAGE,
    INVALID_FIRST_NAME_MESSAGE,
    INVALID_JOB_TITLE_MESSAGE,
    INVALID_LAST_NAME_MESSAGE,
} from './steps/validate-file-step/constants';

import type {
    BulkImportUserType,
    ValidatedBulkImportUser,
} from './typedef';
import type {Locale} from '@pb/kit-context-locale';
import type {ValidateColumnValue} from 'src/components/with-interaction-table/typedef';


const NAME_VALIDATION_REGEX = /[^-0-9 A-Za-z_.@+']/g;

export const getValidationHeader = (locale: Locale, totalCount?: number) => {
    const caption = HEADERS[COLUMNS.EMAIL];

    if (totalCount) {
        return `${caption} (${Integer.format(totalCount, locale)})`;
    }

    return caption;
};

export const getRunHeader = (locale: Locale, totalCount?: number) => {
    const caption = HEADERS[COLUMNS.EMAIL];

    if (totalCount) {
        return `${caption} (${Integer.format(totalCount, locale)})`;
    }

    return caption;
};

export const validateColumnValue: ValidateColumnValue = (columnId: string, value: string) => {
    switch (columnId) {
        case COLUMNS.EMAIL:
            const email = value;
            if (!email || email.length > 255 || !isValidEmail(email)) {
                return {
                    reason: INVALID_EMAIL_MESSAGE,
                    message: INVALID_EMAIL_MESSAGE,
                };
            } else {
                return null;
            }
        case COLUMNS.FIRST_NAME:
            const firstName = value;
            if (!firstName || firstName.length > 50 || firstName.replace(NAME_VALIDATION_REGEX, '') !== firstName) {
                return {
                    reason: INVALID_FIRST_NAME_MESSAGE,
                    message: INVALID_FIRST_NAME_MESSAGE,
                };
            } else {
                return null;
            }
        case COLUMNS.LAST_NAME:
            const lastName = value;
            if (!lastName || lastName.length > 50 || lastName.replace(NAME_VALIDATION_REGEX, '') !== lastName) {
                return {
                    reason: INVALID_LAST_NAME_MESSAGE,
                    message: INVALID_LAST_NAME_MESSAGE,
                };
            } else {
                return null;
            }
        case COLUMNS.CITY:
            if (value.length > 50) {
                return {
                    reason: INVALID_CITY_MESSAGE,
                    message: INVALID_CITY_MESSAGE,
                };
            } else {
                return null;
            }
        case COLUMNS.JOB_TITLE:
            if (value.length > 200) {
                return {
                    reason: INVALID_JOB_TITLE_MESSAGE,
                    message: INVALID_JOB_TITLE_MESSAGE,
                };
            } else {
                return null;
            }
        default:
            return null;
    }
};

type GetValidatedFields = (user: BulkImportUserType) => ValidatedBulkImportUser;
export const getValidatedFields: GetValidatedFields = (user: BulkImportUserType) => {
    const {
        id: _id,
        userStatus: _userStatus,
        userType: _userType,
        newsletters: _newsletterType,
        group: _group,
        country: _country,
        priorAccount: _priorAccount,
        targetAccount: _targetAccount,
        importSettings: _importSettings,
        ...validatedFields
    } = user;

    return validatedFields;
};

type GetValidationError = (user: BulkImportUserType) => string | null;
export const getValidationError: GetValidationError = user => {
    const validatedFields = getValidatedFields(user);

    const validatedKeys = Object.keys(validatedFields) as Array<keyof ValidatedBulkImportUser>;

    return validatedKeys.map(key => {
        const {validationError} = validatedFields[key];
        if (validationError) {
            return validationError;
        } else {
            return null;
        }
    }).filter(Boolean).join(', ') || null;
};
